import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const catalogFiltersSchema = z.object({
  search: z.string().optional(),
  currency: z.enum(['all', 'CLP', 'UF']).default('all'),
  pageSize: z.coerce.number().int().min(10).max(100).default(10),
});

export const productsSearchSchema = globalSearchSchema
  .extend({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
  })
  .merge(catalogFiltersSchema);

export type ProductsSearch = z.infer<typeof productsSearchSchema>;
